import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  addAddress,
  type CreateAddressPayload,
  type SavedAddress,
  type UserProfile,
} from "../api/userService";
import { useAxiosInstance } from "./useAxiosInstance";

export const useAddAddress = ({
  onSuccess,
}: { onSuccess?: (savedAddress: SavedAddress) => void } = {}) => {
  const axiosInstance = useAxiosInstance();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateAddressPayload) =>
      addAddress(axiosInstance, payload),
    onSuccess: (savedAddress) => {
      queryClient.setQueryData<UserProfile>(["user"], (user) =>
        user ? { ...user, addresses: [...user.addresses, savedAddress] } : user,
      );
      onSuccess?.(savedAddress);
    },
  });
};
